<template>
  <div class="" style="">
    <div class="container" style="max-width: 1000px;">
      <div class="container has-text-centered" style="max-width: 900px; margin-bottom: 4rem;">
        <div
          class="is-size-3 welcome-text-heading is-uppercase"
          style="margin-bottom: 20px;"
          v-html="$gettext('welcome.heading')"
        ></div>
        <div
          class="has-text-left welcome-text-above"
          style="margin-bottom: 2rem; text-align: justify !important;"
          v-translate
          :v-translate-params="{ renderedRouterLinkPublicActivities }"
        >welcome.text.above</div>
      </div>

      <div class="level box" style="font-variant: small-caps;">
        <div class="level-item has-text-centered" v-for="rtype in resourceTypes" :key="rtype.type">
          <div>
            <router-link
              class="has-text-garnet"
              :to="{
                name: 'public',
                params: {
                  type: 'ou',
                  id: 1,
                  resourceType: rtype.type
                }
              }"
            >
              <p>
                <translate class="is-size-5">{{ rtype.label }}</translate>
              </p>
              <div class="has-text-basalt is-size-3">
                <p v-if="stats != null">
                  {{ stats[rtype.type].meta.totalEntries.toLocaleString($language.current.substring(0, 2))  }}
                </p>
                <p v-else>
                  &hellip;
                </p>
              </div>
            </router-link>
          </div>
        </div>
      </div>

      <div class="has-text-centered" style="margin-bottom: 2rem;">
        <router-link
          class="has-text-garnet"
          :to="{
            name: 'public',
            params: {
              type: 'ou',
              id: 1,
              resourceType: 'forschungsprojekt'
            }
          }"
        >
          <translate style="text-transform: uppercase; letter-spacing: 1px; padding-right: 0.5rem;" class="is-size-6">welcome.btn.readmore</translate>
          <i class="fa fa-chevron-right" aria-hidden="true"></i>
        </router-link>
      </div>

      <div>
        <h1 class="has-text-centered is-size-4 is-uppercase" style="padding: 2rem;"><translate>welcome.text.like</translate></h1>
        <div class="tile is-ancestor">
          <div class="tile is-parent">
            <article class="tile is-child box">
              <p class="title is-size-5"><translate>welcome.tile.researchprofile.title</translate></p>
              <div stlye="content" v-html="$gettext('welcome.tile.researchprofile.content')"></div>
            </article>
          </div>
          <div class="tile is-parent is-5">
            <article class="tile is-child box">
              <p class="title is-size-5"><translate>welcome.tile.techtransfer.title</translate></p>
              <div stlye="content" v-html="$gettext('welcome.tile.techtransfer.content')"></div>
            </article>
          </div>
          <div class="tile is-parent">
            <article class="tile is-child box">
              <p class="title is-size-5"><translate>welcome.tile.researchservice.title</translate></p>
              <div stlye="content" v-html="$gettext('welcome.tile.researchservice.content')"></div>
            </article>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicTitle from '@/components/mixins/DynamicTitle'
import { fetchStatsQuery } from '@/graphql'
import { graphql } from '@/axios'
import { mapGetters } from 'vuex'

export default {
  name: 'welcome',
  mixins: [DynamicTitle],
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      leurisHead: {
        inner: 'leuris:Portal',
        complement: 'menu.start'
      },
      stats: null
    }
  },
  computed: {
    ...mapGetters({
      userIsAuthorized: 'user/isAuthorized',
      resourceTypes: 'publicView/resourceTypes'
    }),
    renderedRouterLinkPublicActivities () {
      const route = this.$router.resolve({
        name: 'public',
        params: {
          type: 'ou',
          id: 1,
          resourceType: 'forschungsprojekt'
        }
      }, this.$route)
      const linkText = this.$gettext('welcome.researchActivities')
      return `<a href="${route.href}">${linkText}</a>`
    }
  },
  mounted () {
    graphql(fetchStatsQuery(1))
    .then(response => {
      this.stats = response.data.data.organisationalUnit
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.welcome-text-above {
  p {
    margin-bottom: 0.75rem;
  }
}
/* h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
} */

</style>



// WEBPACK FOOTER //
// src/components/Welcome.vue